/**
 * 공통 유틸리티 함수 모음
 */
/**
 * Base64 URL 디코딩 함수 (UTF-8 한글 지원)
 * @param {string} str - Base64 URL로 인코딩된 문자열
 * @returns {string} 디코딩된 문자열
 */
export const base64UrlDecode = (str) => {
  // Base64 URL을 일반 Base64로 변환
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  
  // 패딩 추가
  while (base64.length % 4) {
    base64 += '=';
  }
  
  try {
    // Base64 디코딩
    const binaryString = atob(base64);
    
    // UTF-8 바이트 배열로 변환
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // UTF-8 디코딩
    return new TextDecoder('utf-8').decode(bytes);
  } catch (error) {
    console.error('Base64 decode error:', error);
    // 폴백: 일반 atob 사용
    return atob(base64);
  }
  
};

 // ==================== 숫자 포맷팅 함수 ====================
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return new Intl.NumberFormat('ko-KR').format(num);
};

export const getToday = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

/**
 * yyyyMMdd 형식 문자열을 Date 객체로 변환하는 헬퍼 함수
 * @param {string} yyyymmdd - "20250505" 형식의 날짜 문자열
 * @returns {Date} Date 객체
 */
const parseYyyyMmDd = (yyyymmdd) => {
  if (!yyyymmdd || yyyymmdd.length !== 8) {
    throw new Error('날짜 형식이 올바르지 않습니다. yyyyMMdd 형식이어야 합니다.');
  }
  const year = parseInt(yyyymmdd.substring(0, 4), 10);
  const month = parseInt(yyyymmdd.substring(4, 6), 10) - 1; // 월은 0부터 시작
  const day = parseInt(yyyymmdd.substring(6, 8), 10);
  return new Date(year, month, day);
};

/**
 * Date 객체를 yyyyMMdd 형식 문자열로 변환하는 헬퍼 함수
 * @param {Date} date - Date 객체
 * @returns {string} "20250505" 형식의 날짜 문자열
 */
const formatYyyyMmDd = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

/**
 * 날짜에 월을 더하는 함수
 * @param {string} yyyymmdd - "20250505" 형식의 날짜 문자열
 * @param {number} addMonth - 더할 월 수 (음수 가능)
 * @returns {string} "20250505" 형식의 날짜 문자열
 */
export const monthAdd = (yyyymmdd, addMonth) => {
  const date = parseYyyyMmDd(yyyymmdd);
  date.setMonth(date.getMonth() + addMonth);
  return formatYyyyMmDd(date);
};

/**
 * 날짜에 년을 더하는 함수
 * @param {string} yyyymmdd - "20250505" 형식의 날짜 문자열
 * @param {number} addYear - 더할 년 수 (음수 가능)
 * @returns {string} "20250505" 형식의 날짜 문자열
 */
export const yearAdd = (yyyymmdd, addYear) => {
  const date = parseYyyyMmDd(yyyymmdd);
  date.setFullYear(date.getFullYear() + addYear);
  return formatYyyyMmDd(date);
};

/**
 * 날짜에 일을 더하는 함수
 * @param {string} yyyymmdd - "20250505" 형식의 날짜 문자열
 * @param {number} addDay - 더할 일 수 (음수 가능)
 * @returns {string} "20250505" 형식의 날짜 문자열
 */
export const dayAdd = (yyyymmdd, addDay) => {
  const date = parseYyyyMmDd(yyyymmdd);
  date.setDate(date.getDate() + addDay);
  return formatYyyyMmDd(date);
};

/**
 * 날짜를 포맷팅하는 함수
 * @param {string} yyyymmdd - "20250505" 형식의 날짜 문자열
 * @returns {string} "2025-05-05" 형식의 날짜 문자열
 */
export const formatDateYYYYMMDD = (yyyymmdd) => {
  if (!yyyymmdd || yyyymmdd.length !== 8) {
    return '';
  }
  const year = yyyymmdd.substring(0, 4);
  const month = yyyymmdd.substring(4, 6);
  const day = yyyymmdd.substring(6, 8);
  return `${year}-${month}-${day}`;
  
};